var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[(_vm.$slots.image)?_c('div',[_vm._t("image")],2):_c('img',{attrs:{"src":require("@/assets/img/Dominio.svg"),"alt":"Vazio"}}),_c('h1',[_vm._v(_vm._s(this.title))]),_c('p',[_vm._v(_vm._s(this.message))]),(_vm.buttonText)?_c('button',{on:{"click":_vm.execute}},[_vm._v(_vm._s(this.buttonText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }